import { z } from "zod";
import createTreezorDocumentUploadForUser from "./createTreezorDocumentUploadForUser.js";

export default {
  params: z.object({
    accountId: z.string(),
  }),
  response: createTreezorDocumentUploadForUser.response,
};
